// extracted by mini-css-extract-plugin
export default {"rightPanelSectionHeader":"GCMI5EyclU1WDl3dA8qh","leftContainer":"DrFc5DcTNeFpbeFLhwtV","title":"xoZ6_302MLAVoTiSB9cV","rightContentContainer":"rBPmHt5zxHZlUV9oXLAf"};